import React, { FunctionComponent } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
interface Props {
  hideNavigation?: boolean;
}

export const ToastContainerSharedComponent: FunctionComponent<Props> = () => {
  return (
    <Styles>
      <ToastContainer autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} draggable pauseOnHover />
    </Styles>
  );
};
const Styles = styled.div`
  --toastify-z-index: 99999;
`;
